import type { MarkRect } from './stageMarks';

/** A box on the stage: the one being drawn, or the mark waiting for (or with) Lykke. */
export function StageBox({ r, tone, label }: { r: MarkRect; tone: 'select' | 'mark'; label?: string }) {
  const mark = tone === 'mark';
  return (
    <div data-stage-ui="" className="pointer-events-none absolute z-[60]" style={{ left: `${r.x}%`, top: `${r.y}%`, width: `${r.w}%`, height: `${r.h}%`, border: `${mark ? 2 : 1}px ${mark ? 'dashed' : 'solid'} #be43ff`, background: mark ? 'rgba(190,67,255,0.08)' : 'rgba(190,67,255,0.06)', borderRadius: mark ? 8 : 2 }}>
      {label && <span className={`absolute ${r.y < 7 ? 'left-1 top-1' : '-top-[26px] left-0'} whitespace-nowrap rounded-full bg-[#be43ff] px-2 py-0.5 text-[11px] font-semibold text-white shadow`}>{label}</span>}
    </div>
  );
}
